import { useRef, useEffect } from 'react';
import { Toast } from 'primereact/toast';
import { setGlobalToastRef } from '../componentes/FuncionesLocales';
import AppToast from './AppToast';

export default function GlobalToastProvider({ children }) {
  const toastRef = useRef(null);

  useEffect(() => {
    setGlobalToastRef({
      current: {
        show: (mensaje) =>
          toastRef.current?.show({
            ...mensaje,
            content: () => (
              <AppToast
                titulo={mensaje.summary}
                mensaje={mensaje.detail}
                severity={mensaje.severity}
              />
            ),
          }),
      },
    });
    
    // Cleanup al desmontar
    return () => {
      setGlobalToastRef(null);
    };
  }, []);

  return (
    <>
      <Toast ref={toastRef} position="custom" className="app-toast" />
      {children}
    </>
  );
}
